// src/pages/FoodDetail.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getFoodItem, IMAGE_URL } from "../api/api";
import { useCart } from "../context/CartContext";
import "../styles/FoodDetail.css";
import RelatedItems from "./RelatedItems";

const FoodDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const [item, setItem]         = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);

  useEffect(() => {
    getFoodItem(id)
      .then((res) => setItem(res.data))
      .catch((e) => {
        console.error(e);
        setError("Could not load item.");
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <p className="detail-loading">Loading...</p>;
  if (error)   return <p className="detail-error">{error}</p>;
  if (!item)   return null;

  const price = parseFloat(item.price) || 0;

  const handleAddToCart = async () => {
    const stored = localStorage.getItem("user");
    if (!stored) {
      alert("Please log in to add items.");
      return navigate("/login");
    }

    await addToCart(item, quantity);
  };

  return (
    <div className="detail-container">
      <div className="detail-card">
        <img
          className="detail-image"
          src={`${IMAGE_URL}${item.image}`}
          alt={item.name}
        />
        <div className="detail-info">
          <h2 className="detail-name">{item.name}</h2>
          {item.description && <p className="detail-desc">{item.description}</p>}
          <div className="detail-price">₹{price.toFixed(2)}</div>

          <div className="detail-actions">
            <label className="detail-quantity">
              <span>Quantity</span>
              <input
                type="number"
                min="1"
                value={quantity}
                onChange={(e) =>
                  setQuantity(Math.max(1, parseInt(e.target.value, 10) || 1))
                }
              />
            </label>
            <button className="detail-btn cart" onClick={handleAddToCart}>
              Add to Cart
            </button>
          </div>
        </div>
      </div>
      <RelatedItems excludeId={id} count={4} />
    </div>
  );
};

export default FoodDetail;
